/**
 * Configración de la constante de CHANNEL, para el canal de comunicación de la app
 *
 * *Constant CHANNEL configuration, for app communication channel *
 */
export const CHANNEL = {
  ABRECUENTAS: {
    NAME: 'abrecuentas',
  },
  MOCKAPP: {
    NAME: 'mock-app',
    CODE: '000',
  },
  SUPERAPP: {
    NAME: 'super-app',
    CODE: '141',
    PRE: './assets/resources/application_flow.json',
    POST: './assets/resources/application_flow_post_login.json',
  },
  PORTALPN: {
    NAME: 'portal-pn',
    CODE: '131',
    PRE: './assets/resources/application_flow_pre_login.json',
    POST: './assets/resources/application_flow_post_login.json',
  },
  PORTALO: {
    NAME: 'portal-operador',
    CODE: '159',
    PRE: './assets/resources/application_flow_pre_login.json',
    POST: './assets/resources/application_flow_post_login.json',
  },
  PORTALPN2: {
    NAME: 'portal-pn',
    CODE: '160',
    PRE: './assets/resources/application_flow_pre_login.json',
    POST: './assets/resources/application_flow_post_login.json',
  },
  PORTALALLIES: {
    NAME: 'portal-pn',
    CODE: '163',
    PRE: './assets/resources/application_flow_pre_login.json',
    POST: './assets/resources/application_flow_post_login.json',
  },
};

export const navCode = {
  0 : '0',
  1 : '1',
  2 : '2',
  200 : '200',
  201 : '201',
  202 : '202',
  203 : '203',
  204 : '204',
  205 : '205',
  206 : '206',
  207 : '207',
  301 : '301',
  208 : '208',
};

export const CODE_NAVIGATION = {
  CODE_0 : '0',
  CODE_1 : '1',
  CODE_2 : '2',
  CODE_200 : '200',
  CODE_201 : '201',
  CODE_202 : '202',
  CODE_203 : '203',
  CODE_204 : '204',
  CODE_205 : '205',
  CODE_206 : '206',
  CODE_207 : '207',
  CODE_208 : '208',
  CODE_301 : '301',
};
